import React from "react";
import { DefaultButton, IconButton, Label, Dropdown } from "@fluentui/react";
import "./TaskReport.css";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useQuery } from "react-query";
import SpinningLoader from "./../Loaders/SpinningLoader.js";

async function getUsersChargeTime(tasks) {
  const _tasks = [...tasks];
  for (let [index, task] of tasks.entries()) {
    const resp = await axios.get(
      `https://w5hmwhltfk.execute-api.us-east-2.amazonaws.com/Prod/emp/${task.AssignedTo}`
    );
    const { data } = resp;
    let totalTime = 0;

    if (data?.length > 0) {
      data.forEach((userTask) => {
        const time =
          Number(userTask?.TaskWorkedHours?.split?.("hrs")?.[0]) || 0;
        if (userTask.TaskId === task.id) {
          totalTime += time;
        }
      });
      if ("chargedTime" in _tasks[index]) {
        _tasks[index].chargedTime += totalTime;
      } else {
        _tasks[index].chargedTime = totalTime;
      }
    }
  }

  return _tasks;
}

const getApiData = async () => {
  let list = [];
  const { data: response } = await axios.get(
    `https://ik66dbp4jb.execute-api.us-east-2.amazonaws.com/Prod`,
    { headers: { "Content-Type": "application/json" } }
  );
  const unApprovedTask = response.filter(
    (elm) =>
      elm?.TaskApproval?.toLowerCase() !== "approved" &&
      elm?.AssignedTo &&
      elm?.TaskDescription &&
      elm?.TaskName &&
      elm?.TimeAllocated
  );
  if (unApprovedTask?.length > 0) {
    list = await getUsersChargeTime(unApprovedTask);
  }

  return list;
};

const dropdownStyles = {
  callout: { maxHeight: 200 },
  dropdown: { width: 200 },
};

const postApiData = async (data) => {
  const { data: response } = await axios.post(
    `https://ik66dbp4jb.execute-api.us-east-2.amazonaws.com/Prod`,
    data,
    { headers: { "Content-Type": "application/json" } }
  );
  return response;
};

const getFilterDropdownOptions = async () => {
  const { data } = await axios.get(
    "https://mgt4g63xtf.execute-api.us-east-2.amazonaws.com/Prod"
  );
  return data;
};

export default function TaskReport() {
  const [filterVal, setFilterVal] = React.useState("All");
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const {
    data: dataForUser,
    isLoading,
    refetch,
  } = useQuery("getApiData", getApiData, {
    cacheTime: 0,
    staleTime: Infinity,
    onSuccess: () => {
      setLoading(false);
    },
  });

  const handleApprove = (e, item) => {
    let taskStatus = e.currentTarget.name;

    let dataBody = {
      ...item,
      TaskApproval: "Approved",
      TaskStatus: taskStatus === "completed" ? "Completed" : "Rejected",
      TaskStartDate: "09-01-2022",
      TaskEndDate: "09-01-2022",
    };
    setLoading(true);
    mutate(dataBody);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const { mutate } = useMutation(postApiData, {
    onSuccess: (response) => {
      const { TaskStatus } = response || {};
      if (TaskStatus?.toLowerCase() === "completed") {
        alert("Task completed successfully!");
      }
      if (TaskStatus?.toLowerCase() === "rejected") {
        alert("Task rejected successfully!");
      }
      refetch();
    },
    onError: (error) => {
      alert(error?.message);
      setLoading(false);
    },
  });

  const { data: optionsData } = useQuery(
    "getFilterDropdownOptions",
    getFilterDropdownOptions,
    { staleTime: Infinity }
  );

  const options = React.useMemo(() => {
    let optionArr = optionsData?.map((d) => {
      return {
        key: d.loginid,
        text: d.loginid,
      };
    });

    if (optionArr) {
      return [{ key: "All", text: "" }, ...optionArr];
    }
  }, [optionsData]);

  const renderTable = (dataList) => {
    return (
      <>
        {dataList.length === 0 ? (
          <center className="no-data">No Task found for this user</center>
        ) : (
          ""
        )}
        {dataList?.map((elm, index) => {
          return (
            <tr key={index}>
              <td className="radio_btn">
                <input type="radio" name="task" id="task-id" />
                <span className="radio_btn">{elm.TaskName}</span>
              </td>
              <td className="td">{elm.TimeAllocated}</td>
              <td className="td">{elm.TaskStatus}</td>
              <td className="td">
                {elm?.chargedTime ? elm?.chargedTime + "hrs" : "-"}
              </td>
              <td className="icon_data">
                <IconButton
                  iconProps={{ iconName: "CheckMark" }}
                  onClick={(e) => handleApprove(e, elm)}
                  name="completed"
                  className="tick_btn"
                />
                <br />

                <IconButton
                  iconProps={{ iconName: "Cancel" }}
                  onClick={(e) => handleApprove(e, elm)}
                  name="rejected"
                  className="cancel_btn"
                />
              </td>
            </tr>
          );
        })}
      </>
    );
  };

  if (isLoading || loading) {
    return <SpinningLoader isLoading={isLoading || loading} />;
  }

  return (
    <center>
      {<SpinningLoader /> && loading}
      <div className="logout-btn">
        <DefaultButton onClick={() => handleLogout()}>Logout</DefaultButton>
      </div>
      <div className="page-background">
        <div className="header-container">
          <p className="main_heading">Task Approval</p>
          <div className="filterDropdown">
            <Dropdown
              onChange={(e, item) => setFilterVal(item.key)}
              options={options}
              styles={dropdownStyles}
              name="AssignedTo"
            />
            &nbsp;
            <Label className="task-header">Assign to: </Label>
          </div>
        </div>
        <div className="table-list">
          <table>
            <thead className="task-header">
              <tr>
                <td className="radio_btn">Task Name</td>
                <td>Allocated Time</td>
                <td>Status</td>
                <td>Charged Time</td>
                <td>Approve / Reject</td>
              </tr>
            </thead>
            <tbody>
              {dataForUser.length > 0 && filterVal === "All"
                ? renderTable(dataForUser)
                : renderTable(
                    dataForUser.filter((elm) => elm.AssignedTo === filterVal)
                  )}
            </tbody>
          </table>
        </div>
      </div>
    </center>
  );
}
